import React from "react";
import { Box, Button, Checkbox, Modal } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import PinchToZoomAndPanImage from "./PinchToZoomAndPanImage.js";

export const DisclaimerDialog = ({
  open,
  disclaimerData,
  description,
  currentIndex,
  onPrev,
  onNext,
  isFunction,
  checkDisclaimerLog,
  setCheckDisclaimerLog,
  showTextReminder,
  setShowTextReminder,
  onCancel,
  onAccept,
  onClose,
}) => {
  if (!open || !disclaimerData) return null;

  const pictures = disclaimerData?.pictures || [];

  return (
    <Modal open={open} onClose={!open}>
      <Box className="disclaimer-container">
        <Box
          className={`${
            pictures.length > 0
              ? "disclaimer-body-photo"
              : "disclaimer-body-photo-hidden"
          }`}
        >
          <div style={{ overflow: "scroll", width: "100%", height: "100%" }}>
            <PinchToZoomAndPanImage
              src={pictures.length > 0 ? pictures[currentIndex].url : ""}
            />
          </div>
          <ChevronLeftIcon
            onClick={onPrev}
            style={{
              fontSize: "30px",
              color: "#fff",
              cursor: "pointer",
              backgroundColor: "rgb(25, 148, 106)",
              borderRadius: "50%",
              position: "absolute",
              left: 0,
              top: "50%",
            }}
          />
          <ChevronRightIcon
            onClick={onNext}
            style={{
              fontSize: "30px",
              color: "#fff",
              cursor: "pointer",
              backgroundColor: "rgb(25, 148, 106)",
              borderRadius: "50%",
              position: "absolute",
              right: 0,
              top: "50%",
            }}
          />
        </Box>
        <Box className="disclaimer-body-container">
          <p className="disclaimer-body-text">{description}</p>

          <div hidden={isFunction ? false : true}>
            <Checkbox
              style={{
                marginLeft: "1.5rem",
                marginTop: "10px",
                marginBottom: "10px",
              }}
              onClick={(e) => {
                if (e.target.checked) {
                  setCheckDisclaimerLog(true);
                } else {
                  return null;
                }
              }}
              disabled={checkDisclaimerLog ? true : false}
            />
            ตกลงและยอมรับเงื่อนไข
          </div>
          {showTextReminder && (
            <p
              style={{
                color: "red",
                marginLeft: "1.5rem",
                marginTop: "10px",
                marginBottom: "10px",
              }}
            >
              *กรุณายอมรับเงื่อนไขก่อน
            </p>
          )}
          <div className="disclaimer-body-footer">
            <div
              className="button-container"
              hidden={isFunction ? false : true}
            >
              <Button
                onClick={onCancel}
                style={{
                  backgroundColor: "white",
                  color: "#19946a",
                  border: "1px solid #19946a",
                  marginRight: "1rem",
                }}
              >
                ยกเลิก
              </Button>
              <Button
                onClick={() => {
                  if (checkDisclaimerLog) {
                    onAccept();
                  } else {
                    setShowTextReminder(true);
                  }
                }}
                style={{
                  backgroundColor: "green",
                  color: "white",
                  border: "1px solid #19946a",
                }}
              >
                ยืนยัน
              </Button>
            </div>
            <div
              hidden={isFunction ? true : false}
              className="button-container"
            >
              <Button
                onClick={onClose}
                type="primary"
                style={{
                  backgroundColor: "green",
                  color: "white",
                  border: "1px solid #19946a",
                }}
              >
                ปิด
              </Button>
            </div>
          </div>
        </Box>
      </Box>
    </Modal>
  );
};

export default DisclaimerDialog;
